// src/data/defaultContent.js

export function getDefaultAboutContent() {
  return {
    hero: {
      title: "PRAY IN VERSES",
      description: "Turning every verse into prayers",
      motivation:
        "And he spake a parable unto them to this end, that men ought always to pray, and not to faint ",
      about:
        " Pray in Verses is a unique devotional platform designed to help you connect deeply with God's Word through prayer. Instead of  rushing through chapters or skimming familiar passages, this resource guides you to pray scripture itself - one verse at a  time. Each verse becomes not just something to read, but something   to internalize, declare, and live out. Our goal is to bridge the  gap between Bible study and prayer life by turning every verse",
    },
    story: {
      title: "Born from a Heart for Prayer",
      paragraphs: [
        "Pray the Bible was born from a simple yet profound realization: prayer becomes more meaningful when anchored in God's own words. We believe that Scripture-based prayer transforms not just our requests, but our entire relationship with the Divine.",
        "What started as a personal journey of discovery has grown into a platform that helps thousands of believers worldwide deepen their prayer life through the beautiful marriage of Scripture and supplication.",
      ],
      quote: "Your word is a lamp for my feet, a light on my path.",
      quoteAuthor: "Psalm 119:105",
    },
    features: [
      {
        title: "Scripture-Centered",
        description:
          "Every prayer is rooted in biblical verses, connecting your heart to God's eternal truth.",
      },
      {
        title: "Personal Journey",
        description:
          "Track your spiritual growth with personalized prayer journals and progress insights.",
      },
      {
        title: "Community Support",
        description:
          "Join a loving community of believers sharing prayers, testimonies, and encouragement.",
      },
      {
        title: "Safe & Sacred",
        description:
          "Your prayers and personal reflections are protected in a secure, reverent environment.",
      },
    ],
    stats: [
      { number: "50K+", label: "Active Users" },
      { number: "1M+", label: "Prayers Offered" },
      { number: "10K+", label: "Verses Explored" },
      { number: "95%", label: "User Satisfaction" },
    ],
    vision: {
      title: "Our Vision",
      description:
        "We envision a world where every believer has access to meaningful, Scripture-based prayer resources that nurture spiritual growth, foster community connection, and deepen their relationship with God through His eternal Word.",
    },
  };
}

export function getDefaultMissionContent() {
  return {
    hero: {
      title: "Our",
      highlight: "Mission",
      description:
        "To revolutionize the way believers engage with prayer by seamlessly weaving Scripture into every spiritual conversation with God.",
    },
    missionStatement:
      "To empower believers worldwide with Scripture-centered prayer tools that deepen their relationship with God, strengthen their faith community, and transform their spiritual journey.",
    coreValues: [
      {
        title: "Scripture Foundation",
        description:
          "Every feature, prayer, and interaction is built upon the solid foundation of Biblical truth.",
      },
      {
        title: "Authentic Connection",
        description:
          "Fostering genuine relationships between believers and their Creator through heartfelt prayer.",
      },
      {
        title: "Community Unity",
        description:
          "Building bridges between believers worldwide, creating a global family united in faith.",
      },
      {
        title: "Excellence in Service",
        description:
          "Delivering exceptional spiritual tools that honor God and serve His people with distinction.",
      },
    ],
    initiatives: [
      {
        title: "Global Prayer Network",
        description:
          "Connecting believers across continents for unified prayer and spiritual support.",
        impact: "150+ Countries Reached",
      },
      {
        title: "Youth Prayer Movement",
        description:
          "Empowering the next generation with Scripture-based prayer habits and spiritual disciplines.",
        impact: "25K+ Young Believers",
      },
      {
        title: "Multilingual Access",
        description:
          "Breaking language barriers to make prayer resources accessible to all nations and tongues.",
        impact: "12 Languages Supported",
      },
    ],
    goals: [
      {
        year: "2024",
        title: "Community Expansion",
        description:
          "Reach 100,000 active users and launch advanced community features",
        status: "In Progress",
      },
      {
        year: "2025",
        title: "Global Outreach",
        description:
          "Expand to 25 languages and establish regional prayer leaders",
        status: "Planned",
      },
      {
        year: "2026",
        title: "Educational Integration",
        description:
          "Partner with seminaries and churches for structured prayer education",
        status: "Vision",
      },
    ],
  };
}
